import AfterSalesService from "../../../services/requests/AfterSalesService";
import handlerErrorMP from "../../../domain/AfterSales/handlerErrorMP";

import {
  GET_ITEMS,
  GET_ERROR,
  GET_INSTALLMENTS,
  GET_TRANSACTION_AMOUNT,
  SET_CARDHOLDER_NAME,
  SET_ERROR,
  SET_INSTALLMENTS,
  SET_TRANSACTION_AMOUNT,
  SET_ITEMS,
  ISSUER,
  SET_LENGTH_CVV,
  GET_LENGTH_CVV,
  SET_ERROR_FIELDS,
  GET_ERROR_FIELDS,
  SET_AUCTION_ID,
  GET_AUCTION_ID,
  SET_AUCTIONEER_ID,
  GET_AUCTIONEER_ID,
  SET_TRANSACTION_AMOUNT_IMMUTABLE,
  GET_TRANSACTION_AMOUNT_IMMUTABLE,
  LOADING,
  SUBMIT_FORM_CREDIT_CARD,
  SUBMIT,
  RESPONSE,
  INVALIDATE_BUTTON_SUBMIT,
  SUBMIT_PIX,
  EXTERNAL_REFERENCE
} from "../actions/checkout";

const state = {
  itemOfCart: [],
  transactionAmount: 0,
  transactionAmountImmutable: 0,
  auctionId: null,
  loading: false,

  invalidateSubmitButton: false,

  //mercado pago
  cardholderName: null,
  error: null,
  errorFields: null,
  issuer: null,
  lengthCvv: 3,
  installments: null,
  triggerSubmit: false,
  triggerSubmitCreditCardForm: false,
  auctioneerId: null,
  response: null,
  submitPix: false,
  externalReference: null,
};

const mutations = {
  [SET_ITEMS]: (state, value) => state.itemOfCart = value,
  [SET_TRANSACTION_AMOUNT]: (state, value) => state.transactionAmount = value,
  [SET_TRANSACTION_AMOUNT_IMMUTABLE]: (state, value) => state.transactionAmountImmutable = value,
  [SET_AUCTION_ID]: (state, value) => state.auctionId = value,

  //mercado pago
  [RESPONSE]: (state, value) => state.response = value,

  [SET_CARDHOLDER_NAME]: (state, name) => state.cardholderName = name,

  [ISSUER]: (state, issuer) => state.issuer = issuer,

  [SET_ERROR]: (state, error) => state.error = error,

  [SET_INSTALLMENTS]: (state, value) => state.installments = value,

  [SET_LENGTH_CVV]: (state, value) => state.lengthCvv = value,

  [SET_ERROR_FIELDS]: (state, field) => state.errorFields = field,

  [SUBMIT]: (state, value) => state.triggerSubmit = value,

  [SUBMIT_FORM_CREDIT_CARD]: (state, value) => state.triggerSubmitCreditCardForm = value,

  [SET_AUCTIONEER_ID]: (state, value) => state.auctioneerId = value,

  [EXTERNAL_REFERENCE]: (state, value) => state.externalReference = value,

  [LOADING]: (state, value) => state.loading = value,

  [INVALIDATE_BUTTON_SUBMIT]: (state, value) => state.invalidateSubmitButton = value,

  [SUBMIT_PIX]: (state, value) => state.submitPix = value,
};

const actions = {
  [SET_ITEMS]: ({commit}, items) => {
    commit(SET_ITEMS, items);
  },
  [SET_TRANSACTION_AMOUNT]: ({commit}, transactionAmount) => {
    commit(SET_TRANSACTION_AMOUNT, transactionAmount);
  },

  [SET_TRANSACTION_AMOUNT_IMMUTABLE]: ({commit}, transactionAmountImmutable) => {
    commit(SET_TRANSACTION_AMOUNT_IMMUTABLE, transactionAmountImmutable);
  },

  //mercado pago
  async getInstallments({ commit }, params) {
    try {
      const getInstallments = await (new AfterSalesService).getInstallments(
        params.lotIdMd5,
        params.isLuxury,
        params.value
      );

      const installments = (getInstallments.data.data.installments);
      if (installments.lenght <= 0) {
        throw new Error('Forma de pagamento indisponível, tente outra.');
      }

      commit(SET_TRANSACTION_AMOUNT, installments[2].total);
      commit(SET_INSTALLMENTS, installments);
    } catch (error) {
      commit(SET_ERROR, {
        message: 'Erro ao buscar dados de parcelas',
        reason: error.message,
        type: 'critical'
      });
    }
  },

  setIssuer({commit}, issuer) {
    commit(ISSUER, issuer);
  },

  settingsCvv({commit}, settings) {
    if (settings && settings.length > 0) {
      commit(SET_LENGTH_CVV, settings[0].security_code.length);
    }
  },

  resetData({commit}) {
    commit(ISSUER, null);
    commit(SET_LENGTH_CVV, 3);
    commit(SET_ERROR_FIELDS, null);
    commit(SUBMIT_FORM_CREDIT_CARD, false);
    commit(SUBMIT_PIX, false);
    commit(SET_ERROR, null);
    commit(INVALIDATE_BUTTON_SUBMIT, false);
  },

  validate({commit}, params ) {
    if (params && params.error != undefined) {
      params.error.map(er => {
        const error = {
          field: params.field,
          detail: er.code
        }
        const message = handlerErrorMP(error);

        Object.assign(error, { message: message });
        if (er.code == 205 && params.field == 'cardNumber') {
          commit(ISSUER, null)
        }
        commit(SET_ERROR_FIELDS, error);
      })
    } else {
      commit(SET_ERROR_FIELDS, null);
    }
  },

  invalidateSubmitButton({ commit }, value) {
    commit(INVALIDATE_BUTTON_SUBMIT, value);
  },

  hasAuctionDiff({ getters }) {
    if (getters.getItems && getters.getItems.length > 0) {
      const auctionIds = getters.getItems.map(item => item.auction_id);

      const [firstId, ...rest] = auctionIds;

      const allMatch = rest.every(id => id === firstId);

      return allMatch ? false : true;
    }
    return true;
  },

  async createPayment({ commit }, payload) {
    try {
      commit(LOADING, true);
      commit(RESPONSE, null);

      const response = await (new AfterSalesService)
        .submitProcessPayment(payload.type, payload);

      const dataResponse = response.data.data;

      commit(RESPONSE, dataResponse);

      return response.data.data;
    } catch (error) {
      const responseError = error.response.data.error;
      let reasons = ['unexpected_error'];

      if ('context' in responseError) {
        const context = responseError.context;
        reasons = Object.values(context).flat();
      }

      commit(SET_ERROR, {
        message: 'Ocorreu um erro',
        reasons: reasons,
        type: 'response_error'
      });
    } finally {
      commit(LOADING, false);
    }
  },

  findPaymentby({ commit }, params) {
    commit(LOADING, true);
    return new Promise((resolve, reject) => {
      (new AfterSalesService).findPaymentStatus(
        params.paymentId,
        params.auctioneerId
      ).then(resp => {
        const data = (resp.data.data);
        if (resp.status <= 200 && resp.status < 300) {
          commit(RESPONSE, data);
          resolve(data);
        }
        reject('error');
      })
      .catch (error => {
        const responseError = error.response.data.error;
        let reasons = ['unexpected_error'];

        commit(SET_ERROR, {
          message: 'Ocorreu um erro',
          reasons: reasons,
          type: 'response_error'
        });

        reject(responseError);
      }).finally(() => {
        commit(LOADING, false);
      });
    })
  },

  triggerSubmit({commit}, paymentMethod) {
    if (paymentMethod == 'credit_card') {
      commit(SUBMIT_FORM_CREDIT_CARD, true);
    } else if (paymentMethod == 'pix') {
      commit(SUBMIT_PIX, true);
    }
  },

  mapFirebaseToPayment({commit}, dataSnapshot) {
    const mapResult = {
      paymentId: dataSnapshot.pagamento_id,
      status: dataSnapshot.status,
      detail: dataSnapshot.detalhe,
      methodPayment: dataSnapshot.metodo_pagamento,
      installments: dataSnapshot.parcela,
      transactionAmount: dataSnapshot.transactionAmount,
      typePayment: dataSnapshot.tipo_pagamento,
      qrCode: typeof dataSnapshot.codepix !== 'undefined' ? dataSnapshot.codepix : null,
      qrCodeBase64: typeof dataSnapshot.qrCode !== 'undefined' ? dataSnapshot.qrCode : null,
      dateExpiration: typeof dataSnapshot.data_expiracao !== 'undefined' ? dataSnapshot.data_expiracao : null,
    };
    commit(RESPONSE, mapResult);
    return mapResult;
  },

  generateExternalReference({commit, getters}) {
    const timestamp = Date.now().toString().slice(-6);
    const refenece = `9${timestamp}${getters.getItems.length}${getters.getAuctionId}${getters.getAuctioneerId}`;
    commit(EXTERNAL_REFERENCE, refenece);
  }
};

const getters = {
  [GET_ITEMS]: (state) => state.itemOfCart,
  [GET_TRANSACTION_AMOUNT]: (state) => state.transactionAmount,
  [GET_TRANSACTION_AMOUNT_IMMUTABLE]: (state) => state.transactionAmountImmutable,
  [GET_ERROR]: (state) => state.error,
  [GET_ERROR_FIELDS]: (state) => state.errorFields,
  [GET_INSTALLMENTS]: state => state.installments,
  [ISSUER]: (state) => state.issuer,
  [GET_LENGTH_CVV]: (state) => state.lengthCvv,
  [GET_ERROR_FIELDS]: (state) => state.errorFields,
  [GET_AUCTION_ID]: (state) => state.auctionId,
  [GET_AUCTIONEER_ID]: (state) => state.auctioneerId,
  [LOADING]: (state) => state.loading,
  [SUBMIT_FORM_CREDIT_CARD]: (state) => state.triggerSubmitCreditCardForm,
  [RESPONSE]: (state) => state.response,
  [INVALIDATE_BUTTON_SUBMIT]: (state) => state.invalidateSubmitButton,
  [SUBMIT_PIX]: (state) => state.submitPix,
  [EXTERNAL_REFERENCE]: (state) => state.externalReference,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
